module.exports = __webpack_public_path__ + "img/19.55d55f1f.png";